import { Select } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { spanishProvinces } from "../helpers/spanish-provinces";

type Props = {
  id: string;
  value?: string;
  onChange: (value: string) => void;
  size?: string;
};

export const ProvinceSelect = ({ id, value, onChange, size }: Props) => {
  const { t } = useTranslation();

  return (
    <Select
      id={id}
      size={size}
      borderColor="slate.200"
      placeholder={t("taxProfile.province")}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
    >
      {[...spanishProvinces].sort((a, b) => a.name.localeCompare(b.name, "es")).map((province) => (
        <option key={province.code} value={province.code}>
          {province.name}
        </option>
      ))}
    </Select>
  );
};
